import React, { Component } from 'react'
import { Navbar, Nav, NavItem } from 'react-bootstrap'

class Header extends Component {
  render() {
    return (
      <Navbar inverse>
        <Navbar.Header>
          <Navbar.Brand>it's my words</Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav pullRight>
            {this.props.user.id ?
              [
                <NavItem key={1} onClick={this.props.logoutUser}>Выход</NavItem>,
                <NavItem key={2} onClick={this.props.getProfile}>{this.props.user.login}</NavItem>,
              ] :
              [
                <NavItem key={1} onClick={this.props.toggleLoginModal}>Войти</NavItem>,
                <button key={2} className="btn btn-success navbar-btn" onClick={this.props.toggleRegistrationModal}>Бесплатная регистрация</button>,
              ]
            }
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js